import { IAllPoiList } from '../api/define';

const cache: { [index: number]: IAllPoiList } = {};

const setCache = (poiList: IAllPoiList[]) => {
    poiList.forEach(poi => {
        cache[poi.id] = poi;
    });
};

const getPoiInfoById = (wmPoiId: number): IAllPoiList | null => {
    return cache[wmPoiId] || null;
};

const getPoiNameById = (wmPoiId: number) => {
    const poiInfo = getPoiInfoById(wmPoiId);

    return (poiInfo && poiInfo.poiName) || undefined;
};

const getPoiCount = () => {
    return Object.keys(cache).length;
};

export default { getPoiInfoById, setCache, getPoiNameById, getPoiCount };
